module.exports = __webpack_public_path__ + "static/media/bg2.69ddb635.jpg";